import Text from 'components/base/Text';
import React from 'react';
import LogoWithDudeWrapper from './LogoWithDudeWrapper';

export const InvitationRequested = () => {
  return (
    <LogoWithDudeWrapper>
      <Text size='x-x-x-large' pt='2rem' weight='300'>
        See you soon!
      </Text>
      <>
        <Text
          size='large'
          pt='3rem'
          pr='3rem'
          pl='3rem'
          weight='400'
          align='center'
        >
          We just sent your company admin a request to add you to LinearB. Check
          your email for the invitation
        </Text>
        <Text size='medium' pt='3rem' pb='1rem' weight='400' align='center'>
          In the meantime, you’re welcome to watch our product tour:
        </Text>
        <iframe
          title='Product Tour'
          src='https://player.vimeo.com/video/468391135'
          width='230'
          height='130'
          allowFullScreen
        />
      </>
    </LogoWithDudeWrapper>
  );
};
